import {createSlice} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";

const initialState = {
    isOpen: false,
}


const buyMembershipSlice = createSlice({
    name: "buyMembershipSlice", initialState: initialState, reducers: {
        openMemberShipModal: (state) => {
            state.isOpen = true;
            return state
        }, closeMemberShipModal: (state) => {
            state.isOpen = false;
            return state
        }, toggleMemberShipModal: (state) => {
            state.isOpen = !state.isOpen;
            return state
        },
        setMemberShipModal: (state, action) => {
            state.isOpen = action.payload;
            return state
        }
    }
})


export const {openMemberShipModal,setMemberShipModal, closeMemberShipModal, toggleMemberShipModal} = buyMembershipSlice.actions

export function useMemberShipModal() {
    const dispatch = useDispatch();
    const isOpen = useSelector(state => state.buyMembershipSlice.isOpen);

    const open = () => {
        dispatch(openMemberShipModal());
    }
    const close = () => {
        dispatch(closeMemberShipModal());
    }
    const toggle = () => {
        dispatch(toggleMemberShipModal());
    }
    const set = (value) => {
        dispatch(setMemberShipModal(value));
    }

    const actions = {
        open, close, toggle,set
    }
    return [isOpen, actions]
}

export default buyMembershipSlice.reducer